import ApiClient from './ApiClient';

class DeliveryZonesAPI extends ApiClient {
  constructor() {
    super('delivery_zones', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(zoneId) {
    return axios.get(`${this.url}/${zoneId}`);
  }

  create(data) {
    return axios.post(this.url, { delivery_zone: data });
  }

  update(zoneId, data) {
    return axios.patch(`${this.url}/${zoneId}`, { delivery_zone: data });
  }

  delete(zoneId) {
    return axios.delete(`${this.url}/${zoneId}`);
  }

  toggleActive(zoneId) {
    return axios.post(`${this.url}/${zoneId}/toggle_active`);
  }
}

export default new DeliveryZonesAPI();
